import { ChallengeTeamMemberEntity, UserFitnessSummaryEntity, UserProfileEntity } from '../../../meta-data/app-meta-data.service';
export function memberProfile(member: ChallengeTeamMemberEntity): UserProfileEntity { return member.UserChallenge?.UserProfile; }
export function memberName(member: ChallengeTeamMemberEntity): string {
    const person = memberProfile(member)?.DwUser;
    return [person?.FirstName, person?.LastName].filter(Boolean).join(' ').trim() || 'Streaker';
}
export function challengeHasStarted(startDate: string, now = Date.now()): boolean {
    const start = Date.parse(startDate);
    return Number.isFinite(start) && now >= start;
}
export type TeamCardMode = 'compact' | 'normal' | 'full';
export interface TeamCardSummary {
    members: ChallengeTeamMemberEntity[];
    summaries: UserFitnessSummaryEntity[];
    activities: number | null;
    durationSeconds: number | null;
    missed: number | null;
    longest: number | null;
}
export function summarizeTeam(members: ChallengeTeamMemberEntity[], summaries: UserFitnessSummaryEntity[]): TeamCardSummary {
    const ids = Array.from(new Set(members.map(member => member.UserChallengeId)));
    const complete = ids.length > 0 && ids.every(id => summaries.filter(row => row.UserChallengeId === id).length === 1);
    const available = (select: (row: UserFitnessSummaryEntity) => number) => complete && summaries.every(row => select(row) != null && Number.isFinite(select(row)));
    const sum = (select: (row: UserFitnessSummaryEntity) => number) => available(select) ? summaries.reduce((value, row) => value + select(row), 0) : null;
    return { members, summaries, activities: sum(row => row.TotalActivities), durationSeconds: sum(row => row.TotalDurationSeconds),
        missed: sum(row => row.TotalMissedDays), longest: available(row => row.LongestStreakDays) ? Math.max(...summaries.map(row => row.LongestStreakDays)) : null };
}
